import EditIcon from '../EditIcon/EditIcon';
import { Container, EditIconContainer, ImageWrapper, ProfileImage } from './MerchantProfilePicture.styles';
import { GRAYSCALE_200, GRAYSCALE_300, PRIMARY, WHITE } from '../../styles/colors';

export type MerchantProfilePictureProps = {
    url?: string;
    backgroundColor?: string;
    size?: number;
    borderColor?: string;
    borderWidth?: number;
    placeholderIconWidth?: number;
    placeholderIconHeight?: number;
    placeholderIconFill?: string;
    onClick?: (event: React.MouseEvent) => void;
};

const MerchantProfilePicture = ({
    url,
    backgroundColor,
    size,
    borderColor,
    borderWidth,
    placeholderIconWidth,
    placeholderIconHeight,
    placeholderIconFill,
    onClick,
}: MerchantProfilePictureProps) => {
    return (
        <Container
            $backgroundColor={onClick ? GRAYSCALE_200 : backgroundColor}
            $size={onClick ? 64 : size}
            $borderColor={onClick ? PRIMARY : borderColor}
            $borderWidth={onClick ? 1.5 : borderWidth}
            $isClickable={!!onClick}
            onClick={onClick}
        >
            <ImageWrapper>
                {url ? (
                    <ProfileImage
                        src={url.startsWith('data:')
                            ? url // Don't modify data URLs
                            : `${url}${url.includes('?') ? '&' : '?'}cacheBust=${Date.now()}`}
                        alt="merchantpic"
                    />
                ) : (
                    <PlaceholderIcon
                        width={onClick ? 26 : placeholderIconWidth}
                        height={onClick ? 26 : placeholderIconHeight}
                        fill={onClick ? GRAYSCALE_300 : placeholderIconFill}
                    />
                )}
            </ImageWrapper>

            {onClick && <EditIconContainer>
                <EditIcon
                    iconSize={10}
                    containerSize={18}
                    iconColor={WHITE}
                    containerBorderColor={PRIMARY}
                    containerBackgroundColor={PRIMARY}
                />
            </EditIconContainer>}
        </Container>
    );
};

export default MerchantProfilePicture;

const PlaceholderIcon = ({
    width = 18,
    height = 20,
    fill = 'white'
}: {
    width?: number;
    height?: number;
    fill?: string;
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.8 2.7999C1.8 1.47442 2.87452 0.399902 4.2 0.399902H13.8C15.1255 0.399902 16.2 1.47442 16.2 2.7999V17.1999C16.8627 17.1999 17.4 17.7372 17.4 18.3999C17.4 19.0626 16.8627 19.5999 16.2 19.5999H12.4C11.8477 19.5999 11.4 19.1522 11.4 18.5999V15.9999C11.4 15.3372 10.8627 14.7999 10.2 14.7999H7.8C7.13726 14.7999 6.6 15.3372 6.6 15.9999V18.5999C6.6 19.1522 6.15229 19.5999 5.6 19.5999H1.8C1.13726 19.5999 0.6 19.0626 0.6 18.3999C0.6 17.7372 1.13726 17.1999 1.8 17.1999V2.7999ZM5.4 3.9999H7.8V6.3999H5.4V3.9999ZM7.8 8.7999H5.4V11.1999H7.8V8.7999ZM10.2 3.9999H12.6V6.3999H10.2V3.9999ZM12.6 8.7999H10.2V11.1999H12.6V8.7999Z" fill={fill}/>
        </svg>
    )
}
